import React from 'react';
import PropTypes from 'prop-types';
import Navigation from '~routes/main/userprofile/navigation';
import './style.scss';

function DesktopHeader(props){
    return (
        <div className="desktop-header">
            <h1>Личный кабинет</h1>
            <Navigation {...props} />
        </div>
    );
}

Navigation.propTypes = {
    isNewsUserLogged: PropTypes.bool,
    isLawsUserLogged: PropTypes.bool,
    isLawsAvailable: PropTypes.bool,
};

export default DesktopHeader;
export { DesktopHeader };



// WEBPACK FOOTER //
// ./src/routes/main/userprofile/desktop-header/index.js